import { PatientFormData } from '@/models/Patient.ts';
import { InsuranceType } from '@/models/insurance.ts';

export const insuranceType = [
    {
        value: InsuranceType.PUBLIC,
        label: 'GKV',
    },
    {
        value: InsuranceType.PRIVATE,
        label: 'PKV',
    },
    {
        value: InsuranceType.SELF_PAYER,
        label: 'SZ',
    },
];

export const ACADEMIC_TITLE_SUGGESTIONS = ['Dr.', 'Prof.', 'Prof. Dr.'] as const;

// Anrede options — maps German labels to Insuite salutation codes
export const SALUTATION_OPTIONS = [
    { value: 'NONE', label: '-' },
    { value: 'MR', label: 'Herr' },
    { value: 'MS', label: 'Frau' },
];

// Geschlecht options — maps German labels to Insuite gender codes
export const GENDER_OPTIONS = [
    { value: 'MALE', label: 'Männlich' },
    { value: 'FEMALE', label: 'Weiblich' },
    { value: 'VARIOUS', label: 'Divers' },
    { value: 'UNKNOWN', label: 'Unbekannt' },
    { value: 'UNDEFINED', label: 'Unbestimmt' },
];

// default values for the form
export const defaultValues: PatientFormData = {
    insurance_type: InsuranceType.PUBLIC,
    instance_id: '',
    location_id: '', // practice_id
    academic_title: '',
    salutation: 'NONE', // Default "-"
    gender: '', // Default "bitte wählen"
    first_name: '',
    last_name: '',
    date_of_birth: '',
    street: '',
    house_number: '',
    addon: '',
    postal_code: '',
    city: '',
    country_code: 'DE', // Default to Germany
    email: '',
    phone: '+49',
    landline_phone: '+49',
};
